import dayjs from 'dayjs';

import { RO_DATE_TIME_FORMAT } from '@feature/utils';

export function formatDateTime(date: string | number | undefined) {
  return dayjs.utc(date).tz(dayjs.tz.guess()).format(RO_DATE_TIME_FORMAT);
}

export function formatHumanizedDuration(date: string | number | undefined) {
  return dayjs().to(dayjs.utc(date).tz(dayjs.tz.guess()));
}
